"use client";

import React from "react";
import classnames from "classnames";
import Link from "next/link";

// Components
import styles from "./Button.module.scss";
import type { ButtonProps } from "./interface";

// Utils
import { useHrefFromPageOrURL } from "@/app/[lang]/utils/useHrefFromPageOrURL";

const Button = (props: ButtonProps) => {

  const {
    onClick,
    disabled,
    style,
    className,
    htmlType,
    loading,
    children,
    attributes = {
      text: "",
      url: "",
      newTab: false,
      size: "",
      type: "",
      backgroundColor: "",
      hoverColor: "",
      textColor: "",
      page: {
        data: null
      }
    },
  } = props;

  const {
    text,
    newTab,
    size,
    type = "solid",
    backgroundColor = "black",
    hoverColor = "white",
    textColor = "white",
  } = attributes;

  const buttonClassNames = classnames(
    "button",
    styles.button,
    className,
    size && styles[size],
    loading && styles.loading,
    disabled && styles.disabled,
    type && styles[type],
    {
      [`bg-${ backgroundColor }`]: type === 'solid',
      [`hover-bg-${ hoverColor }`]: type === 'solid',
      [`hover-text-${ hoverColor }`]: ! disabled && type !== 'solid',
      [`hover-text-${ textColor }`]: ! disabled && type === 'solid',
    },
    `text-${ textColor }`
  );
  
  const href = useHrefFromPageOrURL(attributes);

  if ( ! text && ! children) {
    return null;
  }

  if (href) {
    return (
      <Link href={ href } style={ style } className={ buttonClassNames } target={ newTab ? "_blank" : undefined }>
        {children ? children : text}
      </Link>
    );
  } else {
    return (
      <button
        type={ htmlType }
        style={ style }
        onClick={ onClick }
        className={ buttonClassNames }
        disabled={ loading || disabled }
      >
        <span className={ styles.buttonContent }>
          <span>{ children ? children : text }</span>
          { loading && <span className={ styles.loader } /> }
        </span>
      </button>
    );
  }
};

export default Button;
